module.exports = __webpack_public_path__ + "img/Graph.7c0e05f8.png";